import { ComponentPublicInstance, onMounted, onUnmounted, ref, Ref } from "vue";
import { injectRuntimeConfig } from "./runtimeConfig";
import { AdFormInput, AdFormInputTypes } from "@fresh8/types/src";

export function composePopoverForm(
  title: string,
  inputs: AdFormInput<AdFormInputTypes>[]
): {
  targetEl: Ref<HTMLElement | ComponentPublicInstance<any>>;
} {
  const rc = injectRuntimeConfig();
  const elementRef = ref<HTMLElement | ComponentPublicInstance | undefined>();
  const localElRef = ref<HTMLElement | undefined>();

  function hoverCallback(event: Event) {
    event.stopPropagation();
    rc.value.globalEmit?.("brandHover", {
      title,
      inputs,
      el: localElRef.value
    });
  }

  function clickCallback(event: Event) {
    event.preventDefault();
    rc.value.globalEmit?.("brandClick", {
      title,
      inputs,
      el: localElRef.value
    });
  }

  onMounted(() => {
    localElRef.value = (elementRef.value as ComponentPublicInstance)?.$el
      ? (elementRef.value as ComponentPublicInstance)?.$el
      : elementRef.value;

    if (localElRef.value && rc.value.globalEmit) {
      localElRef.value.addEventListener("click", clickCallback);
      localElRef.value.addEventListener("mouseover", hoverCallback);
      if (localElRef.value?.style?.cursor)
        localElRef.value.style.cursor = "pointer";
    }
  });

  onUnmounted(() => {
    if (localElRef.value) {
      // if (localElRef.value?.style?.cursor)
      //   localElRef.value.style.cursor = "initial";
      localElRef.value.removeEventListener("click", clickCallback);
      localElRef.value.removeEventListener("mouseover", hoverCallback);
    }
  });

  return {
    targetEl: elementRef
  };
}
